import { ErrorState } from "@/components/ErrorState";
import Loader from "@/components/loader/Loader";
import TransferContainer from "@/components/shared/transfer/TransferContainer";
import { useMyWalletAndAssets, useProfile } from "@/hooks";
import { queryClient } from "@/services/queryClient";
import { useAppSelector } from "@/store/hooks";
import { makeRequest } from "@/utils/makeRequest";
import { useState } from "react";

interface TransferPayload {
  assetId: string;
  networkId: string;
  to: string;
  amount: string;
  otp: string;
  securityCode: string;
}

const UserTransfer = () => {
  const { user } = useAppSelector((state) => state.auth);
  const userId = user?.id;

  const [isLoading, setIsLoading] = useState(false);

  const {
    data: profile,
    isLoading: isLoadingProfile,
    isError,
    refetch: refetchProfile,
  } = useProfile(userId as string);

  const {
    data: myWallet,
    isLoading: isLoadingWallet,
    isError: isErrorWallet,
    refetch,
  } = useMyWalletAndAssets(userId!);

  const transfer = async (payload: TransferPayload) => {
    setIsLoading(true);
    try {
      await makeRequest.post("/blockchain/transfer", payload);

      await queryClient.invalidateQueries({
        queryKey: ["wallet", userId],
      });

      await queryClient.invalidateQueries({
        queryKey: ["profile", userId],
      });

      await queryClient.invalidateQueries({
        queryKey: ["transactions", user?.id, 1],
      });

      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoadingWallet) {
    return <Loader type="bounce" />;
  }

  if (isError) {
    return (
      <ErrorState
        onRetry={() => {
          refetch();
        }}
      />
    );
  }

  return (
    <div className="w-full mt-10">
      <TransferContainer
        wallet={myWallet}
        onTransfer={transfer}
        isLoading={isLoading}

        // onTransferSuccess={() =>
        //   queryClient.invalidateQueries({
        //     queryKey: ["wallet:my"],
        //   })
        // }
      />
    </div>
  );
};

export default UserTransfer;
